import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { CustomFieldFilter } from "~/components/Filters/CustomFieldFilter/CustomFieldFilter";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { clearCustomFieldFilterValuesAction, setCustomFieldFilterLogicAction, setCustomFieldFilterValuesAction } from "~/store/filters/actions";
import { customFieldFilterLogicSelector, customFieldFilterValuesSelector, hasCustomFieldFilterValuesSelectedSelector } from "~/store/filters/selectors";
import { useGetPrivateCustomFieldOptions } from "~/swr-hooks/customFields/useGetPrivateCustomFieldOptions";
import { selectableCustomFields } from "~/swr-hooks/customFields/utils";
import { useAirSelector } from "~/utils/ReduxUtils";
export const SingleCustomFieldFilter = /*#__PURE__*/ memo((param)=>{
    let { customField, onApplyClick } = param;
    const { id: customFieldId, type: { title: customFieldTypeName } } = customField;
    const { data } = useGetPrivateCustomFieldOptions({
        customFieldId,
        enabled: selectableCustomFields.includes(customFieldTypeName)
    });
    const { searchImprovements } = useTemporaryFeatureFlags();
    const hasValues = useAirSelector((store)=>hasCustomFieldFilterValuesSelectedSelector(store, customFieldId));
    const dispatch = useDispatch();
    const clearValues = useCallback(()=>{
        dispatch(clearCustomFieldFilterValuesAction({
            customFieldId
        }));
    }, [
        customFieldId,
        dispatch
    ]);
    const selectedLogic = useAirSelector((state)=>customFieldFilterLogicSelector(state, customFieldId));
    const selectedValues = useAirSelector((state)=>customFieldFilterValuesSelector(state, customFieldId));
    const onLogicChange = useCallback((logic)=>dispatch(setCustomFieldFilterLogicAction({
            customFieldId,
            logic
        })), [
        dispatch,
        customFieldId
    ]);
    const onSelectedValuesChanged = useCallback((values)=>{
        dispatch(setCustomFieldFilterValuesAction({
            customFieldId,
            values
        }));
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        customFieldId,
        onApplyClick,
        searchImprovements
    ]);
    var _data_data;
    return /*#__PURE__*/ _jsx(SingleFilterContainer, {
        hasValues: hasValues,
        currentFilter: "customField",
        currentCustomField: customField,
        onClearClick: clearValues,
        onApplyClick: onApplyClick,
        children: /*#__PURE__*/ _jsx(CustomFieldFilter, {
            values: (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : [],
            onLogicChange: onLogicChange,
            selectedLogic: selectedLogic,
            selectedValues: selectedValues,
            onSelectedValuesChange: onSelectedValuesChanged
        })
    });
});
SingleCustomFieldFilter.displayName = "SingleCustomFieldFilter";
